"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var PaginationModuleForm_1;
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaginationModuleForm = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const backoffice_1 = require("../../dsl/backoffice");
const form_1 = require("../_abstract/form");
const form_2 = require("../_components/form");
const _contracts_1 = require("../_contracts");
/**
 * Component that contains a complete questionnaire needed to **EDIT** the `PaginationModule`'s contents.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
let PaginationModuleForm = PaginationModuleForm_1 = class PaginationModuleForm extends form_1.AbstractModuleForm {
    constructor() {
        super(...arguments);
        /**
         * @inheritDoc
         * @override
         */
        this.initialContent = PaginationModuleForm_1.getInitialContent();
    }
    /**
     * @inheritDoc
     * @override
     */
    static getInitialConfig() {
        return {
            driver: _contracts_1.ModuleDriver.Pagination,
            size: {
                colSpan: 6,
                rowSpan: 1,
                isResizable: false,
                minColSpan: 6,
                minRowSpan: 1,
                maxColSpan: 6
            }
        };
    }
    /**
     * @inheritDoc
     * @override
     */
    static getInitialContent() {
        return {
            list: null,
            listType: form_2.ListSelectionMode.Default,
            override: false,
            perPage: 1,
            firstPage: 0,
            showDirectionButtons: true,
            totalVisible: 7
        };
    }
    /**
     * TODO: Description.
     *
     * @param source
     */
    setList(source) {
        this._content.list = source;
    }
    /**
     * Parse valid perPage to int
     *
     * @param perPage
     * @protected
     */
    setPerPage(perPage) {
        this._content.perPage = isFinite(parseInt(perPage)) ? parseInt(perPage) : perPage;
    }
    /**
     * Parse valid setTotalVisible to int
     *
     * @param total
     * @protected
     */
    setTotalVisible(total) {
        this._content.totalVisible = isFinite(parseInt(total)) ? parseInt(total) : total;
    }
};
PaginationModuleForm = PaginationModuleForm_1 = __decorate([
    vue_property_decorator_1.Component({
        name: 'PaginationModuleForm',
        components: {
            DashmixCheck: backoffice_1.DashmixCheck,
            DashmixInput: backoffice_1.DashmixInput,
            FormErrors: form_2.FormErrors,
            ListSelector: form_2.ListSelector
        },
        template: `
    <div>
    <!-- List (content source) -->
    <div class="form-group mb-4">
      <label for="list_value" class="d-block">
        {{ $t('forms.pagination.list') }} <span class="text-danger">*</span>
      </label>
      <ListSelector :list="_content.list" @update:list="setList"
                    :listType.sync="_content.listType"
                    v-bind="{ mode, pickRelated, relatedService }"/>
    </div>

    <!-- Articles per page -->
    <div class="form-group">
      <div class="row">
        <div class="col-12 col-md-6">
          <label for="perPage">
            {{ $t('forms.pagination.per-page') }} <span class="text-danger">*</span>
          </label>
          <DashmixInput type="number" :model.sync="_content.perPage" name="perPage" :disabled="!_content.override"
                        @update:model="setPerPage"/>
        </div>
        <div class="col-12 col-md-6">
          <label for="firstPage">
            {{ $t('forms.pagination.first-page') }}
          </label>
          <DashmixInput type="number" :model.sync="_content.perPage + _content.firstPage" name="firstPage" disabled/>
        </div>
      </div>
    </div>

    <div class="form-group">
      <DashmixCheck :model.sync="_content.override" name="override-per-page"
                    :label="$t('forms.pagination.override-per-page')"/>
    </div>

    <!-- Number of pagination items -->
    <div class="form-group">
      <label for="totalVisible">
        {{ $t('forms.pagination.total-visible') }}
      </label>
      <DashmixInput type="number" :model.sync="_content.totalVisible" name="totalVisible"
                    @update:model="setTotalVisible"/>
    </div>

    <!-- Show/hide direction buttons -->
    <div class="form-group">
      <DashmixCheck :model.sync="_content.showDirectionButtons" name="showDirectionButtons"
                    :label="$t('forms.pagination.show-direction-buttons')"/>
    </div>

    <!-- Form errors -->
    <FormErrors v-if="errors" v-bind="{ errors }" class="mt-3"/>
    </div>
  `
    })
], PaginationModuleForm);
exports.PaginationModuleForm = PaginationModuleForm;
//# sourceMappingURL=Pagination.form.js.map